// Import React
import React from 'react';
import styles from './privacyPolicy.module.css'; // Import the CSS module

const PrivacyPolicy = () => {
  return (
    <div className={styles.privacyPolicyPage}>
      <h1 className={styles.title}>Privacy Policy</h1>
      <p className={styles.effectiveDate}>Effective Date: 12.02.2023</p>
      <div className={styles.content}>
        <p>
          At Secret Message Candles, we value your trust and are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and safeguard your personal information when you visit our website, <a href="https://secretmessagecandles.fragrancereviews.in/">https://secretmessagecandles.fragrancereviews.in/</a> (the "Site"). By using our Site, you agree to the practices described in this Privacy Policy.
        </p>

        <h2>1. Information We Collect</h2>
        <p>We collect information to enhance your experience on our Site and to fulfill your orders. The types of information we may collect include:</p>
        <ul>
          <li><strong>Personal Information:</strong> This includes your name, email address, phone number, shipping address, and payment details when you make a purchase or contact us.</li>
          <li><strong>Non-Personal Information:</strong> Technical data such as IP address, browser type, device information, and browsing behavior when you interact with our Site.</li>
          <li><strong>Cookies Information:</strong> Data collected through cookies to improve website functionality and deliver personalized experiences. (See Section 3 for more details on cookies.)</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <p>We use the information collected for the following purposes:</p>
        <ul>
          <li><strong>Order Fulfillment:</strong> To process payments, ship orders, and communicate with you regarding your purchase.</li>
          <li><strong>Customer Service:</strong> To respond to inquiries and resolve any issues.</li>
          <li><strong>Marketing:</strong> To send promotional emails or updates about new products, collections, or offers (only if you have opted in to receive such communication).</li>
          <li><strong>Website Improvement:</strong> To analyze user behavior and enhance site performance, usability, and experience.</li>
        </ul>
        <p>We will never sell, share, or rent your personal information to third parties for their marketing purposes without your explicit consent.</p>

        <h2>3. Cookies and Tracking Technologies</h2>
        <p>
          Our Site uses cookies to provide a seamless browsing experience. Cookies are small files stored on your device that help us understand site usage and preferences. By using our Site, you consent to our use of cookies. You may manage your cookie preferences through your browser settings. However, disabling cookies may limit certain functionalities of our Site.
        </p>

        <h2>4. Sharing Information with Third Parties</h2>
        <p>We may share your information with select third parties only in the following instances:</p>
        <ul>
          <li><strong>Service Providers:</strong> We work with third-party providers to process payments, deliver orders, and operate our website. These providers are required to maintain the confidentiality of your information.</li>
          <li><strong>Legal Requirements:</strong> To comply with legal obligations, enforce our terms of service, or protect the rights and safety of our users.</li>
          <li><strong>Business Transfers:</strong> If Secret Message Candles undergoes a business transition, such as a merger or acquisition, your information may be part of the transferred assets.</li>
        </ul>

        <h2>5. Data Security</h2>
        <p>
          We prioritize the security of your personal information and employ various measures, including encryption and secure servers, to protect your data from unauthorized access, alteration, or disclosure. However, no method of transmission over the Internet or electronic storage is 100% secure. We cannot guarantee absolute security, but we continually work to enhance our safeguards.
        </p>

        <h2>6. Your Rights</h2>
        <p>You have certain rights regarding your personal information, which include:</p>
        <ul>
          <li><strong>Access:</strong> Request access to the personal data we hold about you.</li>
          <li><strong>Correction:</strong> Request corrections to any inaccurate or incomplete information.</li>
          <li><strong>Deletion:</strong> Request that we delete or remove your personal data where no longer necessary.</li>
          <li><strong>Opt-out:</strong> Unsubscribe from our marketing communications by following the instructions in our emails or contacting us directly.</li>
        </ul>

        <h2>7. Contact Information</h2>
        <p>
          For any questions, concerns, or requests regarding your privacy, please contact us at:
          <br />
          <strong>Email:</strong> <a href="mailto:redolencefragrancereviews@gmail.com">redolencefragrancereviews@gmail.com</a>
          <br />
          <strong>Phone:</strong> +91 97172 44643
        </p>
        <p>We are committed to addressing your concerns in a timely and effective manner.</p>

        <h2>8. Changes to this Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. Any updates will be posted on this page with the effective date. We encourage you to review this Privacy Policy periodically.
        </p>

        <p>
          By using our Site, you acknowledge that you have read and understood this Privacy Policy. Thank you for trusting Secret Message Candles to be part of your special moments!
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
